import { BoneWebsocket } from '@sfe/bone-websocket';
import { ls } from '@sfe/bone-cache';
import { getOrigin, WS_DOMAIN_LIST, getUsableOrigin } from '@/config/env';
import { parseUrl } from '@/utils/url';
import { monitor, monitorTypes } from '@/utils/monitor';

// WebSocket 全局透传参数
const params = {
    binary: !ls.get('SPOT_ws_nogzip'),
};

const gateway = new BoneWebsocket({
    url: `${getOrigin({ type: 'ws' })}/spot/ws/quote/v2`,
    autoConnect: !window.sfe.prerender,
    params,
});

gateway.on('close', (data) => {
    const { origin: currentOrigin, pathname, search } = parseUrl(data.url);

    // 初始ws连接失败后，切换新的链路进行连接
    const { origin, isLoop } = getUsableOrigin('gateWay', {
        originList: WS_DOMAIN_LIST,
        currentOrigin,
    });
    const url = `${origin}${pathname}`;
    if (isLoop) {
        gateway.changeLine({ url });
    }

    if (!navigator.onLine) return; // 没有网络不上报
    monitor.counter('ws_close', { r: pathname, m: search, ei: data.errorInfo });
});

let quoteReady = false;
gateway.on('open', (data) => {
    const { pathname, search } = parseUrl(data.url);
    monitor.gauge('ws_open', data.duration, { r: pathname, m: search });
    if (!quoteReady) {
        quoteReady = true;
        monitor.mark('ws_quote_ready', monitorTypes.PAGE_START);
    }
});

export default gateway;
